import { render, staticRenderFns } from "./slider-item.vue?vue&type=template&id=2ca1ceb4"
import script from "./slider-item.vue?vue&type=script&lang=js"
export * from "./slider-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports